import { LayersDataTypes } from "../../../../types/layers-data-types";

export const infraMap = {
  Electricity: "powerSupply",
  Water: "water",
  Telecom: "telecom",
  Sewerage: "drainage",
  Gas: "gas",
} as const;

export const InfrastructureTemplates = {
  [LayersDataTypes.ElectricityInfrastructure]: {
    key: "DistAndDirectionToElectricity",
    template:
      "The nearest location of electricity network is approximately {distance} kilometers to the {direction}.",
  },
  [LayersDataTypes.WaterInfrastructure]: {
    key: "DistAndDirectionToWater",
    template:
      "The nearest location of water network is approximately {distance} kilometers to the {direction}.",
  },
  [LayersDataTypes.TelecomInfrastructure]: {
    key: "DistAndDirectionToTelecom",
    template:
      "The nearest location of telecom network is approximately {distance} kilometers to the {direction}.",
  },
  [LayersDataTypes.SewerageInfrastructure]: {
    key: "DistAndDirectionToSewerage",
    template:
      "The nearest location of sewerage network is approximately {distance} kilometers to the {direction}.",
  },
  [LayersDataTypes.GasInfrastructure]: {
    key: "DistAndDirectionToGas",
    template:
      "The nearest location of gas network is approximately {distance} kilometers to the {direction}.",
  },
} as const;
